var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{attrs:{"id":"divGenericTreeviewList"}},_vm._l((_vm.treeData),function(item,index){return _c('tree-item',{key:index,staticClass:"item",attrs:{"item":item},on:{"make-folder":_vm.makeFolder,"delete-item":_vm.deleteItem,"handle-cancel":_vm.handleCancel,"item-link-clicked":_vm.itemLinkClicked}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }